var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkQuickAccessUsage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.33 6.21h-1.064a1 1 0 0 0-1 1v19.578a1 1 0 0 0 1 1h1.065a1 1 0 0 0 1-1V7.21a1 1 0 0 0-1-1zM26.788 11.115h-1.679a1 1 0 0 0-1 1v14.673a1 1 0 0 0 1 1h1.679a1 1 0 0 0 1-1V12.115a1 1 0 0 0-1-1zM10.483 16.02H9.418a1 1 0 0 0-1 1v9.769a1 1 0 0 0 1 1h1.065a1 1 0 0 0 1-1v-9.77a1 1 0 0 0-1-1z",
    fill: "#DCF4E8",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.055 6.96h3.884a.25.25 0 0 1 .25.25v19.578a.25.25 0 0 1-.25.25h-3.884a.25.25 0 0 1-.25-.25V7.21a.25.25 0 0 1 .25-.25z",
    stroke: "url(#en2e1riata)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.902 11.865h3.885a.25.25 0 0 1 .25.25v14.673a.25.25 0 0 1-.25.25h-3.885a.25.25 0 0 1-.25-.25V12.115a.25.25 0 0 1 .25-.25z",
    stroke: "url(#gvp02sabob)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21 16.77h3.886a.25.25 0 0 1 .25.25v9.769a.25.25 0 0 1-.25.25H7.21a.25.25 0 0 1-.25-.25v-9.77a.25.25 0 0 1 .25-.25z",
    stroke: "url(#u4s5t8bgic)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "en2e1riata",
    x1: 20.019,
    y1: 1.973,
    x2: 15.226,
    y2: 2.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gvp02sabob",
    x1: 27.867,
    y1: 7.84,
    x2: 23.074,
    y2: 7.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u4s5t8bgic",
    x1: 12.175,
    y1: 13.708,
    x2: 7.384,
    y2: 13.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkQuickAccessUsage);
export default __webpack_public_path__ + "static/media/darkQuickAccessUsage.888f78b63245ae5f8bb68d40ef04f34d.svg";
export { ForwardRef as ReactComponent };